import React, { useState } from 'react';
import { Select } from '../../components/Select';
import { useDataContext } from '../../context/data';
import translations from '../../constants/translations.json';

const RestaurantsHeader = ({
  query,
  setQuery,
  selectedCategory,
  categoryOptions,
  onCategorySelect,
  viewMode,
  setViewMode,
  filteredCount,
}) => {
  const [activeGroup, setActiveGroup] = useState('restaurants');
  const { language } = useDataContext();

  return (
    <div className="flex items-center gap-3 flex-wrap">
      {/* Restaurants / Favorites toggle */}
      <div className="flex bg-gray-100 rounded-3xl p-[3px] shrink-0 h-[42px] items-center box-border">
        <button
          onClick={() => setActiveGroup('restaurants')}
          className={`px-4 h-9 border-none rounded-[20px] text-[13px] font-semibold cursor-pointer transition-all duration-200 ${
            activeGroup === 'restaurants' ? 'bg-primary text-white' : 'bg-transparent text-gray-500'
          }`}
        >
          {translations[language]?.restaurants}
        </button>
        <button
          onClick={() => setActiveGroup('favorites')}
          className={`px-4 h-9 border-none rounded-[20px] text-[13px] font-semibold cursor-pointer transition-all duration-200 ${
            activeGroup === 'favorites' ? 'bg-primary text-white' : 'bg-transparent text-gray-500'
          }`}
        >
          {translations[language]?.restaurants_favorites}
        </button>
      </div>

      {/* Search */}
      <div className="relative flex-[1_1_180px] min-w-[140px]">
        <input
          type="text"
          placeholder={translations[language]?.restaurants_search}
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          className="w-full pr-11 pl-4 h-[42px] border-none rounded-3xl text-[13px] text-[#333] bg-gray-100 outline-none box-border"
        />
        <button className="absolute right-1 top-1/2 -translate-y-1/2 w-[34px] h-[34px] rounded-full border-none bg-primary text-white cursor-pointer flex items-center justify-center text-xs">
          <i className="fas fa-chevron-right" />
        </button>
      </div>

      {/* Sort by - only in list view */}
      {viewMode !== 'map' && (
        <div className="flex items-center gap-2 shrink-0">
          <span className="text-[13px] text-gray-400 whitespace-nowrap font-medium">
            {translations[language]?.restaurants_sort}
          </span>
          <div className="min-w-[130px]">
            <Select
              options={categoryOptions || []}
              value={selectedCategory}
              onChange={onCategorySelect}
            />
          </div>
        </div>
      )}

      {/* Separator */}
      <div className="w-px h-6 bg-gray-200 shrink-0" />

      {/* Count */}
      <span className="text-xs text-gray-400 whitespace-nowrap shrink-0">
        <strong className="text-[#333]">{filteredCount}</strong>{' '}
        {translations[language]?.restaurants_places?.toLowerCase() || 'places'}
      </span>

      {/* List / Map toggle */}
      <div className="flex bg-gray-100 rounded-lg p-0.5 shrink-0">
        <button
          onClick={() => setViewMode('list')}
          className={`px-2.5 py-[5px] border-none rounded-md text-[11px] font-semibold cursor-pointer transition-all duration-200 flex items-center gap-1 ${
            viewMode === 'list' ? 'bg-primary text-white' : 'bg-transparent text-gray-500'
          }`}
        >
          <i className="fas fa-th-large text-[10px]" />
          {translations[language]?.restaurants_view_list}
        </button>
        <button
          onClick={() => setViewMode('map')}
          className={`px-2.5 py-[5px] border-none rounded-md text-[11px] font-semibold cursor-pointer transition-all duration-200 flex items-center gap-1 ${
            viewMode === 'map' ? 'bg-primary text-white' : 'bg-transparent text-gray-500'
          }`}
        >
          <i className="fas fa-map-marked-alt text-[10px]" />
          {translations[language]?.restaurants_view_map}
        </button>
      </div>
    </div>
  );
};

export default RestaurantsHeader;
